import { Injectable } from "@nestjs/common";
import { UploadDetailesDto } from "./upload.detailes.dto";
import { UploadDetailesEntity } from "./upload.detailes.entity";

@Injectable()
export class UploadDetailesAdapter {

    public convertDtoToEntity(uploaddetailesdto: UploadDetailesDto): UploadDetailesEntity {

        const entity = new UploadDetailesEntity();

        entity.employeeCode = uploaddetailesdto.employeeCode;
        entity.employeeName = uploaddetailesdto.employeeName;
        entity.gender       = uploaddetailesdto.gender;
        entity.designation  = uploaddetailesdto.designation;
        entity.department   = uploaddetailesdto.department;
        entity.priorityOne  = uploaddetailesdto.priorityOne;
        entity.priorityTwo  = uploaddetailesdto.priorityTwo;
        entity.employeeStatus = uploaddetailesdto.employeeStatus;
        entity.yearOfExperience = uploaddetailesdto.yearOfExperience;
        entity.emailId = uploaddetailesdto.emailId;
        entity.mobileNumber = uploaddetailesdto.mobileNumber;

        return entity;
    }

    public convertEntityToDto(entity: UploadDetailesEntity): UploadDetailesDto {

        const dto = new UploadDetailesDto();
        dto.employeeCode = entity.employeeCode;
        dto.employeeName = entity.employeeName;
        dto.gender = entity.gender;
        dto.designation = entity.designation;
        dto.department = entity.department;
        dto.priorityOne = entity.priorityOne;
        dto.priorityTwo = entity.priorityTwo;
        dto.employeeStatus = entity.employeeStatus;
        dto.yearOfExperience = entity.yearOfExperience;
        dto.emailId = entity.emailId;
        dto.mobileNumber = entity.mobileNumber;

        return dto

    }







}